var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_190_485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 80,
    height: 80,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 14.5,
    stroke: "#EEEEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3371 50.7628C36.0765 50.7628 35.8152 50.6775 35.5964 50.5005C33.9318 49.1584 32.3979 47.9002 30.9081 46.6528C30.3174 46.1584 29.9927 45.4831 29.9927 44.7496C29.9927 43.9804 30.3669 43.2267 31.0186 42.6818C31.8699 41.9708 32.7273 41.2683 33.5855 40.5658L34.8364 39.5374C35.0769 39.3363 35.3181 39.1361 35.5678 38.9474C36.0905 38.5531 36.8327 38.6579 37.2262 39.1826C37.6197 39.7074 37.5146 40.4525 36.9919 40.8468C36.7724 41.0129 36.5613 41.1891 36.3495 41.3661L35.0823 42.4078C34.2303 43.1048 33.379 43.8026 32.5332 44.509C32.3925 44.6269 32.36 44.7247 32.36 44.7496C32.36 44.755 32.3755 44.7845 32.4234 44.8249C33.9025 46.0629 35.4256 47.3126 37.0785 48.6453C37.5888 49.056 37.67 49.805 37.2602 50.3165C37.0267 50.6107 36.6835 50.7628 36.3371 50.7628Z",
    fill: "#3D63C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6639 50.7629C51.3175 50.7629 50.9734 50.6107 50.74 50.3181C50.3302 49.8058 50.4121 49.0583 50.9216 48.6469C52.5731 47.3158 54.0954 46.0661 55.5767 44.8265C55.6247 44.7861 55.6409 44.7566 55.6409 44.7512C55.6409 44.7263 55.6092 44.6285 55.4677 44.5098C54.625 43.8065 53.7753 43.1103 52.9256 42.4148L51.6538 41.3692C51.442 41.193 51.2309 41.0153 51.0106 40.8492C50.4879 40.4541 50.3828 39.7089 50.7755 39.1842C51.1683 38.6595 51.9113 38.554 52.4331 38.9483C52.6836 39.1377 52.9256 39.3387 53.1668 39.5397L54.4224 40.5721C55.2775 41.2722 56.1334 41.9731 56.9823 42.6818C57.6349 43.2267 58.0091 43.9804 58.0091 44.7496C58.0091 45.4824 57.6836 46.1584 57.0929 46.6529C55.6007 47.9018 54.0676 49.16 52.4045 50.5005C52.1857 50.6775 51.9236 50.7629 51.6639 50.7629Z",
    fill: "#3D63C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5992 52.746C40.4206 52.746 40.2405 52.7057 40.0696 52.6195C39.4851 52.3253 39.2485 51.6112 39.5408 51.0236L46.3267 37.4207C46.6197 36.8331 47.331 36.5963 47.9162 36.8897C48.5007 37.1839 48.7373 37.898 48.4451 38.4848L41.6592 52.0886C41.4512 52.5054 41.0337 52.746 40.5992 52.746Z",
    fill: "#3D63C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1481 22.3638C25.7643 22.3638 26.2638 21.8624 26.2638 21.2438C26.2638 20.6252 25.7643 20.1237 25.1481 20.1237C24.532 20.1237 24.0325 20.6252 24.0325 21.2438C24.0325 21.8624 24.532 22.3638 25.1481 22.3638Z",
    fill: "#3D63C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.143 22.3638C29.7591 22.3638 30.2586 21.8624 30.2586 21.2438C30.2586 20.6252 29.7591 20.1237 29.143 20.1237C28.5268 20.1237 28.0273 20.6252 28.0273 21.2438C28.0273 21.8624 28.5268 22.3638 29.143 22.3638Z",
    fill: "#3D63C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1386 22.3638C33.7548 22.3638 34.2542 21.8624 34.2542 21.2438C34.2542 20.6252 33.7548 20.1237 33.1386 20.1237C32.5224 20.1237 32.0229 20.6252 32.0229 21.2438C32.0229 21.8624 32.5224 22.3638 33.1386 22.3638Z",
    fill: "#3D63C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6024 65H23.3984C20.9731 65 19 63.0191 19 60.5842V35.2046C19 34.5479 19.5304 34.0155 20.1845 34.0155C20.8385 34.0155 21.3689 34.5479 21.3689 35.2046V60.5834C21.3689 61.7073 22.2797 62.6217 23.3992 62.6217H64.6024C65.7219 62.6217 66.6326 61.7073 66.6326 60.5834V19.4158C66.6326 18.2919 65.7219 17.3775 64.6024 17.3775H23.3984C22.2789 17.3775 21.3681 18.2919 21.3681 19.4158V23.0229C21.3681 24.1468 22.2789 25.0612 23.3984 25.0612H61.8098C62.4638 25.0612 62.9942 25.5936 62.9942 26.2503C62.9942 26.907 62.4638 27.4395 61.8098 27.4395H23.3984C20.9731 27.4395 19 25.4586 19 23.0236V19.4158C19 16.9809 20.9731 15 23.3984 15H64.6016C67.0269 15 69 16.9809 69 19.4158V60.5842C69.0008 63.0191 67.0277 65 64.6024 65Z",
    fill: "#3D63C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2146 32.5011C20.8854 32.5011 21.4292 31.9551 21.4292 31.2817C21.4292 30.6082 20.8854 30.0623 20.2146 30.0623C19.5438 30.0623 19 30.6082 19 31.2817C19 31.9551 19.5438 32.5011 20.2146 32.5011Z",
    fill: "#3D63C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_190_485",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_190_485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_190_485",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.c6731bbdb4b02cc2d6f23195c2f91c8b.svg";
export { ForwardRef as ReactComponent };